import React from 'react'
import PropTypes from 'prop-types'
import ErrorMessage from './ErrorMessage'
import Hint from './Hint'

/**
 * @param {React.ReactNode} hint
 * @param {import('./interfaces').HintProps} props
 */
export const getHint = (hint, props = {}) => {
  return hint ? <Hint {...props}>{hint}</Hint> : null
}

/**
 * @param {React.ReactNode} error
 * @param {import('./interfaces').ErrorProps} props
 * @param {string=} id
 */
export const getError = (error, props = {}, id, errorInline) => {
  if (errorInline) return <span role='alert' aria-live='assertive' className='zb-error-message' id={id} {...props}>{error}</span>
  return <ErrorMessage id={id} {...props}>{error}</ErrorMessage>
}

export const errorOptionsType = PropTypes.shape(ErrorMessage.propTypes)

export const hintOptionsType = PropTypes.shape(
  Object.assign({}, Hint.propTypes, {
    children: PropTypes.node,
    label: PropTypes.node
  })
)

const validInputProps = [
  'accept',
  'accessKey',
  'autoCapitalize',
  'autoComplete',
  'autoFocus',
  'class',
  'className',
  'dir',
  'disabled',
  'form',
  'formAction',
  'hidden',
  'id',
  'key',
  'lang',
  'name',
  'pattern',
  'placeholder',
  'readonly',
  'ref',
  'required',
  'size',
  'style',
  'tabIndex',
  'title',
  'role'
]
const inputPrefixes = ['data-', 'aria-', 'item']
const eventHandlerMatcher = /^on[A-Z][a-z]+[A-Za-z]*$/

export const getInputProps = (props = {}) =>
  Object.keys(props).reduce(
    (p, key) =>
      inputPrefixes.some(prefix => key.slice(0, prefix.length) === prefix) ||
      eventHandlerMatcher.test(key) ||
      validInputProps.indexOf(key) !== -1
        ? Object.assign({ [key]: props[key] }, p)
        : p,
    {}
  )

export default {
  getError,
  getHint,
  errorOptionsType,
  hintOptionsType,
  getInputProps
}
